(function () {
  function getParams() {
    const p = new URLSearchParams(window.location.search);
    return {
      cmp: p.get('cmp'),
      name: p.get('Name') || '',
      dname: p.get('DName') || '',
      age: p.get('Age') || '',
      active: p.get('Active') || '',
      sex: p.get('Gender') || p.get('Sex') || '',
      currentCustomer: p.get('CurrentCustomer') || '' // Yes/No
    };
  }

  function cameFromMealPlanRecently(maxMinutes) {
    try {
      const raw = localStorage.getItem('cmp_mealplan');
      if (!raw) return false;
      const data = JSON.parse(raw);
      if (!data.ts) return false;
      const ageMs = Date.now() - data.ts;
      return ageMs <= maxMinutes * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function setText(selector, value) {
    document.querySelectorAll(selector).forEach((el) => {
      el.textContent = value || '';
    });
  }

  function setHTML(selector, value) {
    document.querySelectorAll(selector).forEach((el) => {
      el.innerHTML = value || '';
    });
  }

  function show(el) {
    if (el) el.style.display = '';
  }

  function hide(el) {
    if (el) el.style.display = 'none';
  }

  function getPronouns(sexRaw) {
    const s = (sexRaw || '').toLowerCase().trim();

    if (s.includes('male') || s.includes('boy') || s === 'm') {
      return { subject: 'he', possessive: 'his' };
    }
    if (s.includes('female') || s.includes('girl') || s === 'f') {
      return { subject: 'she', possessive: 'her' };
    }
    return { subject: 'they', possessive: 'their' };
  }

  function getBeVerb(subjectPronoun) {
    return (subjectPronoun || '').toLowerCase() === 'they' ? 'are' : 'is';
  }

  function normaliseActivity(activeRaw) {
    const a = (activeRaw || '').trim();
    if (!a) return '';
    return a.charAt(0).toLowerCase() + a.slice(1);
  }

  function normaliseAge(ageRaw) {
    const a = (ageRaw || '').trim();
    if (!a) return '';

    const lower = a.toLowerCase();
    const range = a.match(/\(([^)]+)\)/);
    const years = range && range[1] ? range[1].replace('-', '–') : '';

    if (lower.startsWith('adult')) return years ? `an adult (${years} years)` : 'an adult';
    if (lower.startsWith('puppy')) return years ? `a puppy (${years} years)` : 'a puppy';
    if (lower.startsWith('kitten')) return years ? `a kitten (${years} years)` : 'a kitten';

    return a;
  }

  function getCustomerStatusMessage(currentCustomerRaw) {
    const v = (currentCustomerRaw || '').toLowerCase().trim();

    if (v === 'yes' || v === 'y' || v.includes('yes') || v === 'true' || v === '1') {
      return 'As an existing customer, you can save 5% by selecting <strong>On Repeat</strong> before adding to your bag.';
    }

    if (v === 'no' || v === 'n' || v.includes('no') || v === 'false' || v === '0') {
      return "Because you're a new customer, you're offered one of our <strong>Welcome Variety Boxes</strong> at a great introductory discount.";
    }

    return '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    const params = getParams();

    const allowed = params.cmp === '1' && cameFromMealPlanRecently(60);

    const wrapper = document.querySelector('.cmp_reco');
    const defaultH1 = document.querySelector('.cmp-product-h1');
    const personalisedTitles = document.querySelectorAll('.cmp_personalised_title');

    // Default state
    if (defaultH1) defaultH1.classList.remove('visually-hidden');
    personalisedTitles.forEach((el) => hide(el));
    if (wrapper) hide(wrapper);

    if (!allowed) return;

    const pronouns = getPronouns(params.sex);
    const beVerb = getBeVerb(pronouns.subject);

    setText('[data-cmp="customer_name"]', params.name);
    setText('[data-cmp="pet_name"]', params.dname);

    setText('[data-cmp="pronoun_subject"]', pronouns.subject);
    setText('[data-cmp="verb_be"]', beVerb);

    const activity = normaliseActivity(params.active);
    setText('[data-cmp="pet_active"]', activity);

    // Hide activity clause entirely if missing (cat quiz)
    document.querySelectorAll('.cmp_activity_clause').forEach((el) => {
      if (!activity) el.classList.add('is-hidden');
      else el.classList.remove('is-hidden');
    });

    setText('[data-cmp="pet_age_natural"]', normaliseAge(params.age));

    // CurrentCustomer messaging
    setHTML('[data-cmp="customer_status"]', getCustomerStatusMessage(params.currentCustomer));

    // Swap titles
    personalisedTitles.forEach((el) => show(el));
    if (defaultH1) defaultH1.classList.add('visually-hidden');

    // Reveal
    if (wrapper) {
      show(wrapper);
      wrapper.removeAttribute('data-cmp-hidden');
    }
  });
})();
